const {groupByEdition} = require('./editions.cjs')

function groupQuestionStandards(items = []) {
  return groupByEdition(items).map(group => ({
    ...group,
    items: [...group.items].sort((a, b) => {
      const left = `${a.expectation || a.id}-${a.code || '00'}`
      const right = `${b.expectation || b.id}-${b.code || '00'}`
      return left.localeCompare(right)
    })
  }))
}

module.exports = {groupQuestionStandards}
